export default __webpack_public_path__ + "static/media/Twitter.694f7311.svg";